/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { Box, Button, Link, Text } from '@chakra-ui/react';
import { format } from 'date-fns';
import NextLink from 'next/link';
import { useMediaQuery } from 'react-responsive';


/* Internal Imports */
/* Components */

/* Services */
import { isVisInViewport } from '@components/Utility/Shared/SharedService';
import { refineUrlDomain } from '@components/Utility/utils';

/**
 * 
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang 
 * @returns 
 */
const FYDRegisterStickyButton = ({ sectionContent, region, language, pageData, FYDdate, csrData }) => {
  const stickbtnData = sectionContent;
  const [disableButton, setDisableButton] = useState(false);
  const [formattedDate, setFormattedDate] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 767 });

  useEffect(() => {
    window.addEventListener("scroll", listenToScroll);
    return () =>
      window.removeEventListener("scroll", listenToScroll);
  }, []);

  useEffect(() => {
    // Check if programData is defined and has the active 'eventPgmId' property
    if (csrData && csrData[0]?.eventPgmId != null) {
      const date = new Date(csrData[0]?.date + 'T10:16:29.060Z');
      const newFormattedDate = format(date, "MMM do yyyy");
      setFormattedDate(newFormattedDate);
      const disableButton = csrData[0]?.eventPgmId === undefined;
      setDisableButton(disableButton);
    }
  }, [setDisableButton, formattedDate]);

  useEffect(() => {
    if (!csrData?.length > 0) {
      setDisableButton(true);
    }
  }, [])

  const listenToScroll = () => {
    const footerDiv = document.getElementById('footer');
    const heightToHideFrom = '17px';

    const winScroll = document.body.scrollTop ||
      document.documentElement.scrollTop;

    if (winScroll > heightToHideFrom && disableButton != true) {
      const footerInViewPort = isVisInViewport(footerDiv);
      // console.log('winScroll', winScroll, registerDiv, inViewPort);
      if (footerInViewPort) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    } else {
      setIsVisible(true);
    }
  };

  return isVisible && !disableButton && (
    <Box
      position="fixed"
      display={{ base: 'block', md: 'block' }}
      top={{ base: "unset", md: "50%" }}
      bottom={{ base: "2%", md: "unset" }}
      zIndex="100"
      bgColor={'#E4DED4'}
      maxH={{ base: '65px', md: '265px' }}
      right={{ base: "unset", md: "5px" }}
      left={{ base: "0", md: "unset" }}
      width={{ base: "100%", md: "auto" }}
      fontFamily="FedraSansStd-book"
      p="6px 20px"
      boxShadow="0 4px 7px 0px #00000040"
      className='aaa'
    >
      <Box display={'flex'} alignItems={'center'} justifyContent={'space-around'}
        flexDirection={{ base: "row", md: "column" }} // Set flexDirection to column for md
      >
        <Box className="savespot">
          <Text fontWeight={500} color="#000000" fontSize="18px">{isVisible}Save Your Spot</Text>
          <Text align={{ base: "center", md: 'center' }} fontWeight={600} color="#D04723" fontSize="18px">{FYDdate}</Text>
        </Box>
        <Box>
          <Button
            background="#CA4E2A"
            border="none"
            borderRadius="5px"
            fontSize="16px"
            _hover={{
              border: 'none',
              textDecor: 'none',
              bg: '#000054',
            }}
            w={{ base: '119px', md: '100px' }}
            m={{ base: "6px auto 6px 20px", md: "auto" }}
            display="flex"
            h="42px"
            fontFamily="OpenSansRegular"
          >
            <NextLink href={disableButton ? "#" : refineUrlDomain(stickbtnData[1]?.linkUrl, region, language)} passHref legacyBehavior>
              <Link
                textDecor="none"
                p="18px 34px 18px 34px"
                _focus={{ outline: '0' }}
                _hover={{ textDecoration: 'none' }}
              >
                {stickbtnData[1]?.buttonText}
              </Link>
            </NextLink>
          </Button>
        </Box>
      </Box>
      <style jsx global>{`
            .savespot {
              margin-top: 0px;
              color: #000000;
              font-family: 'FedraSansStd-book';
              font-size: 18px;
            }
            .savespot p mark {
                background: transparent;
                font-weight: 600;
                color: #D04723;
            }
        `}</style>
    </Box>
  )
}

export default FYDRegisterStickyButton